const Glide    = require('@glidejs/glide');
const Debounce = require('lodash.debounce');

const glideSelector = '.glide';

const slides = new Glide(glideSelector, {
	type: 'carousel',
	autoplay: 5000,
	hoverpause: false,
	gap: 0
});
slides.mount();

let ww   = window.innerWidth;
let wh   = window.innerHeight;
let size = null;

function checkWindowSize() {

	// Only action anything if window is INCREASING in size
	if (window.innerWidth > ww || window.innerHeight > wh) {
		checkSlideImageSizes()
	}
}

const glideEl = document.querySelector(glideSelector);
const imgEls  = document.querySelectorAll('[data-img]');

// If number of loaded images matches number of images in slideshow, add class to slideshow to display it
let imgsLoaded = 0;
function checkLoadedImages() {
	imgsLoaded++;

	if (imgsLoaded === imgEls.length) {
		glideEl.classList.add('glide--initialised');
	}
}

function checkSlideImageSizes() {
	ww = window.innerWidth;
	wh = window.innerHeight;

	let newSize = 's'

	if (wh > 800) {
		newSize = 'm';
	}
	if (ww > wh) {
		newSize = 'l';
	}

	// document.querySelector(glideSelector).classList.add('glide--initialised');

	// If size changed...
	if (newSize != size) {

		let imgs = [];

		// Get image srcs
		for (let slide of imgEls)
		{
			let imgName = slide.getAttribute('data-img');
			let imgPath = "/images/" + imgName + "-" + newSize + ".jpg";
			slide.style.backgroundImage = "url(" + imgPath + ")";
			imgs.push(imgPath);
		}

		// Create new img el for each img src and add load event listener
		for (let img of imgs) {
			let i = new Image();
			i.src = img;
			i.addEventListener('load', checkLoadedImages, false);
		}

		size = newSize;
	}
}
checkSlideImageSizes();

window.addEventListener('resize', Debounce(checkWindowSize, 1000));

